import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import {
  SaveDriverReferralLinkSettingDTO,
  DriverReferralLinkSettingDTO,
} from '../interfaces/driver-referral-link-setting';

@Injectable({ providedIn: 'root' })
export class DriverReferralLinkService {
  url = '/api/driver-referral-link';

  constructor(private http: HttpClient, private handlersFactory: HttpResponsesHandlersFactory) {}

  public getCurrentSettings(): Promise<DriverReferralLinkSettingDTO> {
    return this.http.get<DriverReferralLinkSettingDTO>(`${this.url}/settings`).toPromise();
  }

  public updateSettings(
    request: SaveDriverReferralLinkSettingDTO,
  ): Promise<DriverReferralLinkSettingDTO> {
    return this.http
      .post<DriverReferralLinkSettingDTO>(`${this.url}/settings`, request)
      .toPromise();
  }
}
